export interface SearchFeatureChecks {
    turismo: boolean;
    c4x4: boolean;
    camioneta: boolean;
    invierno: boolean;
    verano: boolean;
    todasEstaciones: boolean;
    runflat: boolean;
    codigoMS: boolean;
    seal: boolean;
    protector: boolean;
    c3pmsf: boolean;
    electrico: boolean;
    semiSlick: boolean;
}

export class SearchFeatureChecksHelper {
    static default(): SearchFeatureChecks {
        return {
            turismo: true,
            c4x4: true,
            camioneta: true,
            invierno: true,
            verano: true,
            todasEstaciones: true,
            runflat: true,
            codigoMS: true,
            seal: true,
            protector: true,
            c3pmsf: true,
            electrico: true,
            semiSlick: true,
        };
    }

    static fromAPI(data: any) {
        const ret = SearchFeatureChecksHelper.default();
        ret.turismo = !!data.TURISMO;
        ret.c4x4 = !!data.C4X4;
        ret.camioneta = !!data.CAMIONETA;
        ret.invierno = !!data.INVIERNO;
        ret.verano = !!data.VERANO;
        ret.todasEstaciones = !!data.TODASESTACIONES;
        ret.runflat = !!data.RUNFLAT;
        ret.codigoMS = !!data.CODIGOMS;
        ret.seal = !!data.SEAL;
        ret.protector = !!data.PROTECTOR;
        ret.c3pmsf = !!data.C3PMSF;
        ret.electrico = !!data.ELECTRICO;
        ret.semiSlick = !!data.SEMI_SLICK;
        return ret;
    }
}
